import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "User Organizations List Config"})
export default class Config {

	@Input({type: InputType.CHECKBOX, title: "Minimal Display (show icons only)"})
	public iconsOnly?: boolean;

	@Input({type: InputType.UNIT, title: "Organization Logo Width"})
	public logoWidth?: string;

	@Input({type: InputType.UNIT, title: "Organization Logo Height"})
	public logoHeight?: string;

}



// WEBPACK FOOTER //
// ./src/panels/organizations/Config.ts